<template>
  <div>
    <div
      class="h-100 position-absolute p-10"
      id="bind-point"
      :class="setSemitransparent ? 'semitransparent' : ''"
      v-drag
    >
      <i
        @click="closeDialog"
        class="cur_pointer iconfont icon-close r position-absolute close-btn"
      ></i>
      <el-row class="table-header">
        <el-col :span="12">
          <span>新增SIS测点关联</span>
        </el-col>
        <el-col :span="12"></el-col>
      </el-row>
      <!-- 测点列表 -->
      <div class="m-t-10 point-table">
        <el-form
          :model="pointForm"
          :rules="pointRules"
          ref="pointForm"
          label-width="85px"
          size="small"
        >
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="测点编码" prop="code">
                <el-input
                  placeholder="请填写测点编码"
                  v-model="pointForm.code"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="测点名称" prop="name">
                <el-input
                  placeholder="请填写测点名称"
                  v-model="pointForm.name"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="测点ID" prop="customerPointId">
                <el-input
                  placeholder="请填写测点ID"
                  v-model="pointForm.customerPointId"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="测点来源" prop="dataSource">
                <el-select class="w-100" filterable v-model="pointForm.dataSource" clearable>
                  <el-option
                    v-for="item in sourceOptions"
                    :label="item.name"
                    :value="item.id"
                    :key="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="单位" prop="unit">
                <el-input placeholder="请填写单位" v-model="pointForm.unit" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="测点周期" prop="cycle">
                <el-input placeholder="请填写测点周期" v-model="pointForm.cycle" clearable>
                  <template slot="append">ms</template>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="测点类型" prop="type">
                <el-select class="w-100" filterable v-model="pointForm.type" clearable>
                  <el-option
                    v-for="item in pointType"
                    :label="item.name"
                    :value="item.value"
                    :key="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="测点驱动" prop="drive">
                <el-select class="w-100" filterable v-model="pointForm.drive" clearable>
                  <el-option
                    v-for="item in driveOptions"
                    :value="item.id"
                    :label="item.name"
                    :key="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="量程上限" prop="upperLimit">
                <el-input
                  placeholder="请填写量程上限"
                  v-model="pointForm.upperLimit"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="量程下限" prop="lowerLimit">
                <el-input
                  placeholder="请填写量程下限"
                  v-model="pointForm.lowerLimit"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="设备编码" prop="tagCode">
                <el-input placeholder="自动获取" v-model="pointForm.tagCode" readonly></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12"></el-col>
          </el-row>
        </el-form>
      </div>
      <div class="flex-row-end">
        <el-button
          size="small"
          @click="resetPointForm"
          v-buttonMonitor="{ name: '重置', operate: 'read' }"
          >重置</el-button
        >
        <el-button
          size="small"
          type="primary"
          :loading="submitLoading"
          @click="submitData"
          v-buttonMonitor="{ name: '保存', operate: 'read' }"
          >保存</el-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import ApiMixinPoint from '@/assets/js/api/measuringPoint'
import ApiMixinDictionaryManagement from '@/assets/js/api/dictionaryManagement'

export default {
  props: {
    tagId: {
      type: String,
      default: '',
    },
    setSemitransparent: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [ApiMixinDictionaryManagement, ApiMixinPoint],
  data() {
    const checkCycle = (rule, value, callback) => {
      const flag =
        _.toString(value)
          .split('.')[0]
          .substring(0, 1) === '0' && _.toString(value).split('.')[0].length > 1
      const check = _.toNumber(value)
      if (value && (!_.isNumber(check) || _.isNaN(check) || flag || check <= 0)) {
        callback(new Error('请输入大于0的有效数字'))
      } else {
        callback()
      }
    }
    return {
      page: {
        pageNo: 1,
        pageSize: 15,
        pageTotal: 0,
      },
      pointData: [],
      idArray: [],
      pointType: [
        { value: 1, name: '模拟量' },
        { value: 2, name: '开关量' },
        { value: 3, name: '逻辑模拟量' },
      ], // 测点类型
      driveOptions: [], // 测点驱动
      pointForm: {
        customerPointId: null,
        dataSource: null,
        code: null,
        name: null,
        unit: null,
        cycle: null,
        type: null,
        drive: null,
        expression: null,
        upperLimit: null,
        lowerLimit: null,
        tagCode: null,
      },
      pointRules: {
        code: [{ required: true, message: '请填写测点编码', trigger: 'blur' }],
        name: [{ required: true, message: '请填写测点名称', trigger: 'blur' }],
        customerPointId: [{ required: true, message: '请填写测点ID', trigger: 'blur' }],
        cycle: [{ validator: checkCycle, trigger: 'blur' }],
        dataSource: [{ required: true, message: '请选择测点来源', trigger: 'change' }],
        type: [{ required: true, message: '请选择测点类型', trigger: 'change' }],
        tagCode: [{ required: true, message: '请指定设备', trigger: 'change' }],
      },
      submitLoading: false,
      sourceOptions: [], // 测点来源
    }
  },
  async created() {
    this.getMeasuringSource()
    await this.getDicData()
  },
  computed: {
    currentProject() {
      return this.$store.getters.currentProject || {}
    },
  },
  methods: {
    // 获取测点来源
    async getMeasuringSource() {
      this.sourceOptions = []
      const res = await this.apiDictionary({
        method: 'query',
        params: {
          where: { typeName: '测点来源' },
          dataPage: { pageSize: 1000, pageNo: 1 },
        },
      })
      if (res && res.success && res.dataList && res.dataList.length) {
        this.sourceOptions = res.dataList
      }
    },
    // 点击模型
    clickModel(code) {
      this.pointForm.tagCode = code
    },
    closeDialog() {
      this.resetPointForm()
      this.$emit('closeComponents')
    },
    // 提交数据
    submitData() {
      this.$refs.pointForm.validate(async (valid) => {
        if (valid) {
          this.submitLoading = true
          const params = {}
          _.assign(params, this.pointForm)
          params.siteId = this.currentProject.id
          params.cycle = params.cycle ? _.toNumber(params.cycle) : -1
          const res = await this.apiPoint({
            method: 'add',
            params,
          })
          this.submitLoading = false
          if (res && res.code === 0 && res.data) {
            this.$message.success('保存成功')
            this.resetPointForm()
          }
        }
      })
    },
    // 获取测点驱动
    async getDicData() {
      this.driveOptions = []
      const res = await this.apiDictionary({
        method: 'query',
        params: {
          where: { typeName: '测点驱动' },
          dataPage: { pageSize: 1000, pageNo: 1 },
        },
      })
      if (res && res.success && res.dataList && res.dataList.length) {
        this.driveOptions = res.dataList
      }
    },
    // 重置
    resetPointForm() {
      this.pointForm = this.$options.data().pointForm
      this.$refs.pointForm.clearValidate()
      this.$refs.pointForm.resetFields()
    },
  },
}
</script>
<style lang="scss" scoped>

#bind-point {
  height: 390px;
  width: 530px;
  left: 8px;
  bottom: 6px;
  background-color: rgba(255, 255, 255, 0.76);
  border-radius: 4px;
  z-index: 99;
  .table-header {
    margin: 10px 0;
  }
  .point-table {
    height: calc(100% - 75px);
  }
}
/deep/ .el-table__body-wrapper {
  background-color: transparent !important;
}
.el-button + .el-button {
  margin-left: 10px;
}
.close-btn {
  top: 5px;
  right: 5px;
}

</style>
